import React from 'react'
import {CATEGORIES} from '../data/categories'
import type {CategoryKey} from '../data/types'
import AiSurgeChart from './AiSurgeChart'
import CategoryHero from './CategoryHero'
import DistributionBoxPlots from './DistributionBoxPlots'
import HeadToHead from './HeadToHead'
import SpendBySize from './SpendBySize'
import SwitchingDestinations from './SwitchingDestinations'
import VendorLeaderboard from './VendorLeaderboard'

interface CategoryContentProps {
  categoryKey: CategoryKey
}

const CategoryContent: React.FC<CategoryContentProps> = ({categoryKey}) => {
  const data = CATEGORIES[categoryKey]

  return (
    <div aria-live="polite">
      <CategoryHero data={data} />
      {data.aiSurge && <AiSurgeChart />}
      <VendorLeaderboard data={data} />
      <SwitchingDestinations data={data} />
      <HeadToHead data={data} />
      <DistributionBoxPlots data={data} />
      <SpendBySize data={data} />
    </div>
  )
}

export default CategoryContent
